import { render, staticRenderFns } from "./GymCard.vue?vue&type=template&id=36ad690a&scoped=true"
import script from "./GymCard.vue?vue&type=script&lang=js"
export * from "./GymCard.vue?vue&type=script&lang=js"
import style0 from "./GymCard.vue?vue&type=style&index=0&id=36ad690a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad690a",
  null
  
)

export default component.exports